<template>

    <span>
      <v-layout mb-4>
        <v-flex xs10 ml-3>
          <h2 class="lime--text lighten-1 pt-3">Gerenciar Descontos</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
          <v-btn
            color="blue-grey"
            class="black--text"
            :to="{name: 'products'}"
          >
            <v-icon dark>keyboard_arrow_left</v-icon>
            Voltar
          </v-btn>
        </v-flex>
      </v-layout>

      <form-product-discount :btnLabel="btnLabel"></form-product-discount>
    </span>
        
</template>

<script>
import FormProductDiscountComponent from "./partial/FormProductDiscountComponent";

export default {
  name: "FormProductDiscountComponent",
  data () {
    return {
        btnLabel: 'Incluir'
    }
  },
  methods: {

  },
  components: {
    formProductDiscount: FormProductDiscountComponent,
  }
};
</script>

<style scoped>

</style>
